/**
 * Returns a safe in-app path for post-login/register redirects.
 * Accepts only relative paths starting with a single "/".
 */
export function getSafeNextLocation(raw) {
  if (typeof raw !== "string") return null;
  const t = raw.trim();
  if (!t.startsWith("/") || t.startsWith("//")) return null;
  return t;
}
